import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import TemplateEditContent from "../../../components/Pages/Templates/Edit";

const { displayName } = config;

export default function TemplateEdit(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Templates Edit`;
  }, []);

  return (
    <Layout>
      <TemplateEditContent />
    </Layout>
  );
}
